module.exports = __webpack_public_path__ + "static/media/bottomNewAndroid.904463ba.png";